import { SkyFlyoutAdapterService } from './flyout-adapter.service';

export const SKY_FLYOUT_PROVIDERS: any[] = [
  SkyFlyoutAdapterService
];
